import { Campaign, CampaignListProps as CampaignsListProps } from '../services/campaign/campaign.type';

export interface CampaignsResponse {
  inactive: Campaign[];
  active: Campaign[];
}

export function toCampaignsListProps(campaignsResponse: CampaignsResponse | undefined): CampaignsListProps {
  if (campaignsResponse === undefined) {
    return {
      activeCampaigns: [],
      inactiveCampaigns: [],
    };
  }

  return {
    activeCampaigns: campaignsResponse.active,
    inactiveCampaigns: campaignsResponse.inactive,
  };
}

export enum CampaignsPillId {
  ACTIVE_CAMPAIGNS = 'active_campaigns',
  INACTIVE_CAMPAIGNS = 'inactive_campaigns',
}
